// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__l0kLG","modalBody":"Modal_modalBody__5QXaR"};